import React from "react"
import {
  Navigate,
  useLocation
} from "react-router-dom"

import "./ProtectedRoute.css"
import { useAuth } from "../hooks/useAuth"
import { CContainer, CSpinner } from "@coreui/react"

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth()
  const location = useLocation()

  if (loading) {
    return (
      <CContainer
        className="d-flex justify-content-center align-items-center protected-route-loading"
      >
        <CSpinner color="primary" />
      </CContainer>
    )
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  return children
}

export default ProtectedRoute
